// extracted by mini-css-extract-plugin
export var aiStarIcon = "_te-2";
export var container = "_te-4";
export var dismissButton = "_te-3";
export var hasPaddingBottom = "_te-6";
export var last = "_te-e";
export var scrollbarThumb = "_te-c";
export var scrollbarTrack = "_te-b";
export var selected = "_te-9";
export var spin = "_te-1";
export var spinning = "_te-0";
export var suggestionItem = "_te-d";
export var suggestionsPanel = "_te-5";
export var tonePill = "_te-8";
export var tonesContainer = "_te-7";
export var unselected = "_te-a";